<div class="container">
    <div id="ready-set-go" [hidden]="!showReadySetGo">
        <app-boggle-text [text]="'Round ' + roundNumber"></app-boggle-text>
        <app-dice-text [text]="readySetGoText"></app-dice-text>
    </div>
</div>
